module.exports = __webpack_public_path__ + "media/images/emoticons/good-acd696594bc05a933771a51b32c4fe4c.gif";